<template>
  <div id="HomePage">
    <!-- 轮播图 -->
    <div id="swiper" class="container-fuild">
      <div class="swiper-container banner-swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in swiperList" @click="bannerClick(index)" :key="index">
            <img class="swiper-lazy" :data-src="item.img" alt="轮播图">
            <div class="swiper-lazy-preloader"></div>
            <div class="swiper-slide-title">
              <h1 :style="{ color: item.color }">{{ item.title }}</h1>
            </div>
          </div>
        </div>
        <!-- 如果需要分页器 -->
        <div class="swiper-pagination" slot="pagination"></div>

        <!-- 如果需要导航按钮 -->
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>
    <!-- /* 解决方案 */ -->
    <div id="whyChooseUs" class="conatiner-fuild">
      <div class="container">
        <div class="conatiner-title">
          <img src="@/assets/img/ds-img/标题点缀1.png">
          <p>解决方案</p>
          <img src="@/assets/img/ds-img/标题点缀1.png">
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-6 col-md-3 server-wrapper" v-for="(item, index) in serverList"
            @click="whyChooseUsClick(index)" :key="index">
            <div class="server-block wow slideInUp" onmouseenter="this.style.color='#28f';this.style.borderColor='red'"
              onmouseleave="this.style.color='red';" :style="{ backgroundImage: 'url(' + item.logo + ')' }">
              <div class="server-blockzhezhao">
                <div class="text-center">
                  <p v-html="item.content"></p>
                  <a href="solution1.html">
                    <img src="@/assets/img/ds-img/进入.png" alt="">
                  </a>
                </div>
              </div>
            </div>
            <p class="s-text">{{ item.title }}</p>
          </div>

        </div>
      </div>
    </div>
    <!-- 客户案例 -->
    <div id="contactUs" class="conatiner-fuild">
      <div class="container contactUs-container">
        <div class="conatiner-title">
          <img src="@/assets/img/ds-img/标题点缀1.png">
          <p>客户案例</p>
          <img src="@/assets/img/ds-img/标题点缀1.png">
        </div>
        <div class="row">
          <!-- 客户案例轮播 -->
          <div class="s-client">
            <div class="swiper-contactUs">
              <div class="swiper-wrapper">
                <div class="swiper-slide" @click="contactUsnClick(index)" v-for="(item, index) in contactUsList"
                  :key="index">
                  <div class="swiper-slide-content">
                    <div><img class="img1" :src="item.img1" alt=""></div>
                    <div class="zhaobox">
                      <img :src="item.img2" alt="">
                      <div class="textco textone">
                        <span>{{ item.title }}</span>
                      </div>
                      <div class="textco texttwo">
                        <h1>{{ item.title }}</h1>
                        <span style="margin-top: -10px;">{{ item.content }}
                        </span>
                      </div>
                      <img :src="item.img3" alt="">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="prevbtn btnss">
              <button class="prev"><img src="@/assets/img/ds-img/向左.png" alt=""></button>
              <button class="next"><img src="@/assets/img/ds-img/向右.png" alt=""></button>
            </div>
          </div>
          <div class="s-more" @click="contactUsChange()">了解更多</div>
        </div>
      </div>
    </div>
    <!-- 最新资讯 -->
    <div id="information" class="conatiner-fuild">
      <div class="container information-container">
        <div class="conatiner-title">
          <img src="@/assets/img/ds-img/标题点缀1.png">
          <p>最新资讯</p>
          <img src="@/assets/img/ds-img/标题点缀1.png">
        </div>
        <div class="row">
          <!-- 最新资讯轮播 -->
          <div class="information-container-mes">
            <div class="carouselzx">
              <div class="images information-swiper swiper-container">
                <div class="swiper-wrapper">
                  <div class="swiper-slide" v-for="(item, index) in informationList" :key="index"
                    @click="informationClick(index)"><img :src="item.img" alt=""></div>
                </div>
                <div class="swiper-pagination information-pagination"></div>
              </div>
            </div>
            <div class="information-content">
              <dl v-for="(item, index) in informationList" :key="index" @click="informationClick(index)">
                <dt>
                  <h1>{{ item.atime1 }}</h1>
                  <p>{{ item.atime2 }}</p>
                </dt>
                <dd class="hover-effect">
                  <h1>{{ item.title }}</h1>
                  <p>{{ item.content }}</p>
                </dd>
              </dl>

            </div>
          </div>
          <div class="s-more" @click="carouselzxChange()">了解更多</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
import { WOW } from 'wowjs';
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
  name: "HomePage",
  components: { VueSlickCarousel },
  data() {
    return {
      settings: {
        centerMode: true,
        centerPadding: '80px',
        focusOnSelect: true,
        infinite: true,
        slidesToShow: 1,
        speed: 1,
        autoplay: true
      },
      swiperList: [
        {
          img: require("@/assets/img/ds-img/banner1.png"),
          path: "",
          title: '数智CNC实训一体机',
          color: 'rgb(90, 138, 163)'
        },
        {
          img: require("@/assets/img/ds-img/banner2.png"),
          path: "",
          title: '数控五轴加工中心',
          color: 'rgb(59, 114, 255)'
        },
        {
          img: require("@/assets/img/ds-img/banner3.png"),
          path: "",
          title: '集成电路实训一体机',
          color: 'rgb(89, 93, 103)'
        },
        {
          img: require("@/assets/img/ds-img/banner4.png"),
          path: "",
          title: '数控便携式设备',
          color: 'rgb(255,255,255)'
        }
      ],
      informationList: [
        {
          img: require("@/assets/img/ds-img/新闻1.png"),
          atime1: '14',
          atime2: '2024.08',
          title: "上海巅思为2024集创赛职业技能赛项助力",
          content: "8月12日, 由工业和信息化部人才交流中心主办、江苏信息职业技术学院和苏州市职业大学承办的2024全国大学生集成电路创新创业大赛职业技能赛项落下帷幕。"
        },
        {
          img: require("@/assets/img/ds-img/新闻2.png"),
          atime1: '25',
          atime2: '2024.07',
          title: "“集成电路制造工艺虚拟仿真技术”专项培训顺利落幕",
          content: "2024年7月21-23日，“集成电路制造工艺虚拟仿真技术”专项培训在无锡科技职业技术学院成功举办!本次活动由全国半导体行业产教融合共同体及无锡市集成电路产教联合体共同指导，上海巅思......"
        },
        {
          img: require("@/assets/img/ds-img/新闻3.png"),
          atime1: '29',
          atime2: '2024.06',
          title: "“渝”见丝路 技创辉煌 中国财富传媒集团与巅思科技携手闪耀重庆“一带一...",
          content: "近日，重庆第二届“一带一路”技能大赛展览圆满落幕，中国财富传媒集团和上海巅思智能科技有限公司（以下简称“巅思科技”）的联合展览，以前沿的科技产品和创新的解决方案，吸引了众多"
        },
      ],
      serverList: [
        {
          href: 'solution1.html',
          logo: require("@/assets/img/ds-img/方案图1.png"),
          title: "数智CNC一体化实训中心解决方案",
          content: "数智CNC一体化实训中心<br>解决方案"
        },
        {
          href: 'solution2.html',
          logo: require("@/assets/img/ds-img/解决2.png"),
          title: "集成电路实训解决方案",
          content: "集成电路实训<br>解决方案"
        },
        {
          href: 'solution3.html',
          logo: require("@/assets/img/ds-img/方案图3.png"),
          title: "元宇宙-工业板块解决方案",
          content: "元宇宙-工业板块<br>解决方案"
        },
      ],
      contactUsList: [
        {
          img1: require("@/assets/img/ds-img/扬州案例图.png"),
          img2: require("@/assets/img/ds-img/”.png"),
          img3: require("@/assets/img/ds-img/icon1.png"),
          title: "扬州技师学院国家级数实一体智能制造实训基地",
          content: "以典型集成电路制造工艺流程，将光刻、刻蚀、薄膜、离子注入等工艺设备虚拟化，开发不同类型的集成电路机台实训系统，学生可以在集成电路一体机上学习不同机台设备的原理和工序操作步骤，通过工艺设置，将不同的机台工序组成工艺线，学生可以学习工艺流程，掌握工艺流程知识。"
        },
        {
          img1: require("@/assets/img/ds-img/无锡案例图.png"),
          img2: require("@/assets/img/ds-img/”.png"),
          img3: require("@/assets/img/ds-img/icon3.png"),
          title: "苏州市职业大学与巅思科技电路实训基地",
          content: "满足创新性、行业综合人才培养需求，并能与其他专业方向联动发展，为学校其他专业的发展，提供一流的、高仿真的开放式、共享式实训实践的创新环境，为学校高质量发展筑牢基座。"
        },
        {
          img1: require("@/assets/img/ds-img/华东案例图.png"),
          img2: require("@/assets/img/ds-img/”.png"),
          img3: require("@/assets/img/ds-img/icon2.png"),
          title: "华东理工大学数字新技术教研实训基地",
          content: "上海巅思智能科技与华东理工大学共建数字新技术教研实训基地，进一步深化校企合作，实践产教融合，无缝对接院校人才培养与企业人才需求，从质与量的维度满足数字经济进入全新发展阶段后对数字化人才的需求。"
        },
      ]
    };
  },
  mounted() {
    /* banner-swiper */
    new Swiper(".banner-swiper", {
      loop: true, // 循环模式选项
      effect: 'fade',
      //自动播放
      autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false
      },
      // 如果需要分页器
      pagination: {
        el: ".banner-swiper .swiper-pagination",
        clickable: true
      },
      // 如果需要前进后退按钮
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      // 延迟加载
      lazy: {
        loadPrevNext: true
      },
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents: true //修改swiper的父元素时，自动初始化swiper
    });
    new Swiper('.swiper-contactUs', {
      slidesPerView: 3,
      spaceBetween: 0,
      centeredSlides: true,
      loop: true,
      autoplay: true,
      navigation: {
        nextEl: '.prevbtn .next',
        prevEl: '.prevbtn .prev',
      }
    });
    /* information-swiper */
    new Swiper('.information-swiper', {
      // loop: true,
      autoplay: true,
      pagination: {
        el: '.information-pagination',
        clickable: true,
      },
    });
    /* wowjs动画 */
    var wow = new WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 0,
      mobile: true,
      live: true
    })
    wow.init();
  },
  methods: {
    informationClick(val) {
      const idPart = val + 2;
      const aname = 'NewsDetail' + idPart
      // console.log(aname);
      this.$router.push({
        name: aname,
        params: {
          id: val
        }
      })
    },
    contactUsnClick(val) {
      let idPart = 0
      if (val == 0) {
        idPart = 5
      } else if (val == 1) {
        idPart = 6
      } else if (val == 2) {
        idPart = 1
      }
      const aname = 'Casedate' + idPart
      // console.log(aname);
      this.$router.push({
        name: aname,
        params: {
          id: idPart
        }
      })
    },
    whyChooseUsClick(val) {
      let idPart = 0
      if (val == 0) {
        idPart = 1
      } else if (val == 1) {
        idPart = 3
      } else if (val == 2) {
        idPart = 7
      }
      const aname = 'Softsdate0' + idPart
      // console.log(aname);
      this.$router.push({
        name: aname,
        params: {
          id: val
        }
      })
    },
    bannerClick(val) {
      console.log(val);

      const idPart = val + 1;
      const aname = 'Softsdate' + idPart
      // console.log(aname);
      this.$router.push({
        name: aname,
        params: {
          id: val
        }
      })
    },
    carouselzxChange() {
      this.$router.push({
        name: 'newsinformation'
      })
    },
    contactUsChange() {
      this.$router.push({
        name: 'service'
      })
    }
  }
};
</script>
<style scoped>
/* 整体盒子 */
#HomePage {
  width: 100%;
}

/* 轮播图 */
/* #swiper {
  height: 600px;
} */

#swiper .banner-swiper {
  width: 100%;
  height: 100%;
}

#swiper .banner-swiper .swiper-slide img {
  width: 100%;
  height: 100%;
}

#swiper .banner-swiper .swiper-slide {
  position: relative;
}

#swiper .banner-swiper .swiper-slide-title {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999999999;
  width: 45%;
  height: 100%;
  line-height: 80px;
}

#swiper .banner-swiper .swiper-slide-title>h1 {
  font-family: "思源黑体";
  font-size: 50px;
  font-weight: 700;
  text-align: center;
  margin-top: 35%;
}

/*增加自定义css class*/
.banner-swiper .swiper-pagination>>>.swiper-pagination-bullet {
  background: none;
  width: 12px;
  height: 12px;
  border: 1px solid rgb(59, 114, 255);
}

.banner-swiper .swiper-pagination>>>.swiper-pagination-bullet-active {
  border: none;
  background: linear-gradient(-42.71deg, rgba(182, 203, 255, 0.8) 15.869%, rgba(164, 130, 255, 0.91) 49.989%, rgb(79, 129, 255) 78.469%);
}

/* 解决方案 */

.container {
  width: 100%;
}

#whyChooseUs {
  padding: 50px 16%;
}

.conatiner-fuild .conatiner-title {
  margin: auto;
  width: 12%;
  line-height: 55px;
  text-align: center;
  margin-bottom: 50px;
  position: relative;
  /* border: 1px solid red; */
}

.conatiner-fuild .conatiner-title p {
  font-size: 32px;
  padding-top: 10px !important;
}

.conatiner-fuild .conatiner-title img:nth-child(1) {
  position: absolute;
  left: 0%;
  top: 40%;
}

.conatiner-fuild .conatiner-title img:nth-of-type(2) {
  position: absolute;
  right: 0;
  top: 40%;
}

#whyChooseUs .server-block {
  width: 100%;
  height: 325px;
  background-size: 100% 100%;
  cursor: pointer;

}


#whyChooseUs .server-block .text-center span {
  border: 1px solid red;
  width: 100%;
}

#whyChooseUs .server-block .server-blockzhezhao {
  opacity: 0;
  padding: 20% 0;
  height: 100%;
  width: 100%;
  border-radius: 10px;
  background: linear-gradient(-45.00deg, rgba(217, 236, 255, 0) 0%, rgba(120, 164, 255, 0.58) 58.321%, rgb(79, 129, 255) 100%);
}

#whyChooseUs .server-block:hover .server-blockzhezhao {
  opacity: 1;
  transition: all 3s ease;
}

#whyChooseUs .server-block:hover .text-center {
  line-height: 50px;
  transition: all 1.5s ease;
}

#whyChooseUs .server-block .text-center {
  color: #fff !important;
  /* border: 1px solid red; */
  font-size: 24px;
  width: 100%;
  height: 100%;
  text-align: center;
  line-height: 40px;
  font-size: 24px;
  position: relative;
  top: 0;
  left: 0;
  display: grid;
  align-items: center;
}

#whyChooseUs .s-text {
  color: rgb(51, 51, 51);
  font-family: "思源黑体";
  font-size: 16px;
  font-weight: 500;
  line-height: 23px;
  letter-spacing: 0px;
  text-align: center;
  margin-top: 18px;
}

#whyChooseUs .server-block a {
  display: inline-block;
  width: 100%;
}

#whyChooseUs .server-block img {
  margin: 0 auto;
}

#whyChooseUs .server-block:hover .text-center p {
  color: #fff;
}

#whyChooseUs .server-block .server-blockzhezhao:before,
#whyChooseUs .server-block .server-blockzhezhao:after,
#whyChooseUs .server-block .server-blockzhezhao .text-center:before,
#whyChooseUs .server-block .server-blockzhezhao .text-center:after {
  content: '';
  position: absolute;
  background: rgb(255, 255, 255);
  opacity: 1;
  /* 确保线条可见 */
  transition: all 1.5s ease;
}

/* 上边框 */
#whyChooseUs .server-block .server-blockzhezhao:before {
  top: 9%;
  left: 13%;
  width: 0;
  /* 初始宽度为0 */
  height: 2px;
}



/* 左边框 */
#whyChooseUs .server-block .server-blockzhezhao:after {
  top: 10%;
  left: 9%;
  width: 1px;
  /* 边框厚度 */
  height: 0;
  /* 初始高度为0 */
}

/* 右边框 */
#whyChooseUs .server-block .server-blockzhezhao .text-center:before {
  top: -18%;
  right: 5%;
  width: 1px;
  /* 初始宽度为0 */
  height: 0;
}

/* 下边框 */
#whyChooseUs .server-block .server-blockzhezhao .text-center::after {
  bottom: -27%;
  left: 10%;
  width: 0;
  /* 初始宽度为0 */
  height: 1px;
}


/* 鼠标悬停时的效果 */
#whyChooseUs .server-block .server-blockzhezhao:hover:before {
  width: 285px;
  /* 鼠标悬停时宽度变为100% */
}


#whyChooseUs .server-block .server-blockzhezhao:hover:after {
  height: 260px;
  /* 鼠标悬停时高度变为100% */
}

/* 鼠标悬停时的效果 */
#whyChooseUs .server-block .server-blockzhezhao:hover .text-center:before {
  height: 260px;
  /* 鼠标悬停时宽度变为100% */
}

#whyChooseUs .server-block .server-blockzhezhao:hover .text-center::after {
  width: 285px;
  /* 鼠标悬停时宽度变为100% */
}

/* 最新资讯 */
#information {
  /* padding: 0 10px 0px 10px; */
  padding: 50px 200px;
  transition: all ease 0.6s;
  background: rgb(245, 248, 255);
}

#information .information-container {
  padding: 0px 50px;
  max-width: 1503px;
  /* border: 1px solid red; */
}

#information .information-container {
  background: rgb(245, 248, 255);
}

#information .information-container .btns {
  margin-left: 28%;
}

#information .information-container button:hover {
  background: rgb(79, 129, 255);
}

#information .information-container button.active {
  background: rgb(79, 129, 255);
}

#information .information-container button {
  width: 17.02px;
  height: 2.09px;
  background: rgb(196, 196, 196);
}

.carousel {
  position: relative;
  width: 100%;
  height: 400px;
  overflow: hidden;
  min-width: 1905px;
}

.information-swiper {
  position: relative;
  width: 100%;
  height: 330px;
  overflow: hidden;
}

.carouselzx {
  /* position: relative; */
  width: 34.4%;
  height: 100%;
  overflow: hidden;
  /* border: 1px solid red; */
}


.s3-content {
  height: 680px;
}

.information-swiper .information-pagination>>>.swiper-pagination-bullet {
  width: 17.02px;
  height: 2.09px;
  background: rgb(196, 196, 196);
  border-radius: 0;
}

.information-swiper .information-pagination>>>.swiper-pagination-bullet:hover {
  background: rgb(79, 129, 255);
}

.information-swiper .information-pagination>>>.swiper-pagination-bullet-active {
  background: rgb(79, 129, 255);
}

#information .information-container .information-container-mes {
  width: 85%;
  height: 330px;
  display: flex;
  margin: auto;
  justify-content: space-between;
  overflow: hidden;
  /* border: 1px solid rgb(0, 255, 21); */
}

#information .information-container .information-container-mes .information-content {
  width: 775px;
  height: 305px;
  /* border: 1px solid rgb(86, 34, 184); */
}

#information .information-container .information-container-mes .information-content dl {
  /* border: 1px solid pink; */
  display: flex;
  font-size: 11px;
  margin-bottom: 4px;
  cursor: pointer;
}

#information .information-container .information-container-mes .information-content dl dt {
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: rgb(255, 255, 255) !important;
  font-family: "思源黑体 CN";
  font-size: 36px;
  font-weight: 400;
  letter-spacing: 0px;
  text-align: center;
  width: 94.24px;
  height: 98px;
  border-radius: 4px 0px 0px 4px;
  background: rgb(199, 216, 255);
}

#information .information-container .information-container-mes .information-content dl dt p {
  font-size: 11px;
}

#information .information-container .information-container-mes .information-content dl dt h1 {
  color: rgb(255, 255, 255) !important;
  font-weight: bold;
  margin: 0;
}

#information .information-container .information-container-mes .information-content dl dd {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 10px;
  width: 680.7px;
  height: 98px;
  background-color: #fff;
  border-radius: 0px 4px 4px 0px;
}

#information .information-container .information-container-mes .information-content dl dd h1 {
  color: rgb(51, 51, 51);
  font-family: "思源黑体";
  font-size: 18px;
  font-weight: bold;
  line-height: 26px;
  letter-spacing: 0px;
  text-align: left;
}

#information .information-container .information-container-mes .information-content dl dd p {
  color: rgb(102, 102, 102);
  font-family: "思源黑体";
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: justify;
}

.hover-effect:hover p,
.hover-effect:hover h1 {
  color: #1E5EFF !important;
}

/* ------------------ */
.s-client {
  height: 350px;
  display: flex;
  justify-content: center;
}

.swiper-contactUs {
  position: relative;
  width: 105%;
  height: 350px;
  overflow: hidden;
  /* border: 1px solid red; */
}

.swiper-slide-content {
  width: 105%;
  height: 100%;
  user-select: none;
  display: flex;
  justify-content: center;
  align-items: center;
}

.swiper-slide {
  transform: scale(.8);
  transition: .3s;
  cursor: pointer;
}

.swiper-slide .textone {
  display: block;
}

.swiper-slide .texttwo {
  display: none;
}

.swiper-slide-content .zhaobox .textone {
  color: red !important;
}

.swiper-slide-active {
  transform: scale(1);
}

.swiper-slide-active .textone {
  display: none;
}

.swiper-slide-active .texttwo {
  display: block;
}

.disable {
  display: none;
}


.swiper-slide-content .img1 {
  width: 100%;
  height: 100%;
}

.swiper-slide-content div:nth-child(1) {
  width: 60%;
  height: 100%;
}

.swiper-slide-content .zhaobox {
  background: url('../assets/img/ds-img/背景罩子.png');
  /* border: 1px solid red; */
  width: 80%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  background-size: cover;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;

}

.swiper-slide-content div:nth-child(2) img:nth-of-type(1) {
  position: absolute;
  right: 15px;
  top: 20px;
}

.swiper-slide-content div:nth-child(2) span {
  width: 80%;
  height: 83.65px;
  position: absolute;
  top: 57%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: rgb(255, 255, 255);
  font-family: "思源黑体";
  font-size: 22px;
  font-weight: 700;
  line-height: 32px;
  letter-spacing: 0px;
  text-align: justify;
}

.swiper-slide-content div:nth-child(2) .texttwo span {
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  width: 82%;
}

.swiper-slide-content div:nth-child(2) .texttwo h1 {
  width: 82%;
}


.swiper-slide-content div:nth-child(2) h1 {
  position: absolute;
  top: 60px;
  left: 25px;
  color: rgb(30, 94, 255);
  font-family: "思源黑体";
  font-size: 20px;
  font-weight: 700;
  line-height: 29px;
  letter-spacing: 0px;
  text-align: justify;
}

.swiper-slide-content div:nth-child(2) img {
  width: 20%;
  height: auto;
}

.swiper-slide-content div:nth-child(2) img:nth-of-type(2) {
  position: absolute;
  right: 0px;
  bottom: 0px;
}

.btnss {
  position: absolute;
  width: 80%;
  max-width: 655px;
  min-width: 532px;
  height: 0;
  margin-top: 8%;
  /* top: 60%; */
  /* border: 1px solid red; */
  z-index: 999999;
  display: flex;
  justify-content: space-between;
  left: 33.8%;
}

/* 当视口宽度大于或等于 1440px 且小于 1903px 时 */
@media (min-width: 1440px) and (max-width: 1903px) {
  .btnss {
    width: 34.5%;
    margin-left: 0%;
  }
}

.btnss button {
  padding: 0;
  margin: 0;
  border: 0;
  outline: 0;
  background-color: transparent;
}

.btnss button img {
  width: 80%;
  height: auto;
}

.btnss button:hover {
  transform: scale(1.5);
  transform-origin: center center;
  cursor: pointer;
}

.s-more {
  /* border: 1px solid red; */
  display: flex;
  justify-content: center;
  align-items: center;
  height: 150px;
}

.s-more {
  display: block;
  width: 220px;
  height: 55px;
  border: 1px solid rgb(79, 129, 255);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.1);
  margin: 50px auto;
  text-align: center;
  line-height: 55px;
  color: rgb(79, 129, 255);
  font-family: "思源黑体";
  font-size: 20px;
  font-weight: 400;
  line-height: 50px;
  letter-spacing: 0px;
  /* margin-bottom: 60px; */
  z-index: 9999999;
  /* background-color: red; */
  cursor: pointer;
}

.s-more:hover {
  color: rgb(79, 129, 255);
}

@media (min-width: 1440px) and (max-width: 1600px) {
  .btnss {
    min-width: 180px;
  }
}

@media (min-width: 1600px) and (max-width: 1800px) {
  .btnss {
    width: 34.5%;
    margin-left: 0%;
  }
}

@media (min-width: 1800px) and (max-width: 1903px) {
  .btnss {
    width: 34.5%;
    margin-left: 0%;
  }
}

/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  #swiper {
    height: 200px;
  }

  #bigData {
    padding: 30px;
  }

  #bigData .bigData-title {
    font-size: 20px;
  }

  #bigData .bigData-device {
    font-size: 20px;
    margin: 10px 0 10px;
  }

  #contactUs {
    height: 200px;
    transition: all ease 0.6s;
  }

  #contactUs .contactUs-container {
    padding-top: 0;
  }

  #contactUs .contactUs-container h1 {
    font-size: 25px;
  }

  #contactUs .contactUs-container h3 {
    font-size: 18px;
  }

  #contactUs .contactUs-container button {
    width: 200px;
    height: 30px;
    margin-top: 20px;
  }

  #contactUs .contactUs-container .contactUs-contactWay span {
    display: inline-block;
    width: 28px;
    height: 28px;
    margin: 10px;
  }

  #whyChooseUs .server-block {
    padding: 50px 0;
    border: 1px solid #ccc;
    border-bottom: 5px solid #ccc;
  }

  #whyChooseUs .server-block img {
    width: 48px;
    height: 48px;
  }

  #whyChooseUs .server-block>p {
    font-size: 20px;
    margin: 30px 0;
  }

  #whyChooseUs .server-block>div {
    color: #ccc;
  }
}

/* 媒体查询（平板） */
@media screen and (min-width: 768px) and (max-width: 996px) {
  #swiper {
    height: 400px;
  }

  #bigData {
    padding: 60px;
  }

  #bigData .bigData-title {
    font-size: 30px;
  }

  #bigData .bigData-device {
    font-size: 30px;
    margin: 30px 0 15px;
  }

  #contactUs {
    height: 300px;
  }

  #contactUs .contactUs-container {
    padding-top: 50px;
  }

  #contactUs .contactUs-container h1 {
    font-size: 30px;
  }

  #contactUs .contactUs-container h3 {
    font-size: 20px;
  }

  #contactUs .contactUs-container button {
    width: 300px;
    height: 50px;
    margin-top: 30px;
  }

  #contactUs .contactUs-container .contactUs-contactWay span {
    display: inline-block;
    width: 32px;
    height: 32px;
    margin: 15px;
  }

  #contactUs .contactUs-container .contactUs-contactWay span {
    display: inline-block;
    width: 32px;
    height: 32px;
    margin: 15px;
  }

  #whyChooseUs {
    padding: 20px 16%;
  }

  #information {
    height: 300px;
  }

  #information .information-container {
    padding-top: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/HomePage.vue